import { Injectable } from '@angular/core';
import { toPriceNumber } from '@gelato-api-ui/core/product-prices/helpers/toPriceNumber';
import { PriceCollection } from '@api-ui-app/src/app/ngrx/e-commerce-product-wizard.reducer';
import { defaultProfitMargin } from '@gelato-api-ui/core/e-commerce/constants/default-profit-margin';

@Injectable({ providedIn: 'root' })
export class DefaultRetailPriceCalculationService {
  private readonly defaultPriceMargin = 1 + defaultProfitMargin / 100;

  getOne(cost: number): number {
    return toPriceNumber(cost * this.defaultPriceMargin);
  }

  getCollection(costs: PriceCollection): PriceCollection {
    return Object.keys(costs).reduce(
      (acc: PriceCollection, productVariantKey: string): PriceCollection => ({
        ...acc,
        [productVariantKey]: this.getOne(costs[productVariantKey]),
      }),
      {},
    );
  }
}
